// extracted by mini-css-extract-plugin
export default {"backButton":"BackButton_backButton__8IViP","icon":"BackButton_icon__T0UiF","label":"BackButton_label__6a5jF"};